import React from 'react';
import {
  Layout, ShoppingBag, Type, Image, Megaphone, Star, Zap, Grid3X3,
  Minus, Play, SeparatorHorizontal, HelpCircle, GalleryHorizontalEnd,
  CreditCard, Timer, BarChart3, MapPin, Share2, Users, Award, Mail, Code2
} from 'lucide-react';

const BLOCK_TYPES = [
  { type: 'hero',         name: 'Hero Banner',   icon: Layout,              description: 'Banner utama' },
  { type: 'products',     name: 'Produk',        icon: ShoppingBag,         description: 'Grid produk' },
  { type: 'text',         name: 'Teks',          icon: Type,                description: 'Blok teks HTML' },
  { type: 'image',        name: 'Gambar',        icon: Image,               description: 'Gambar + caption' },
  { type: 'banner',       name: 'Banner Promo',  icon: Megaphone,           description: 'Banner promosi' },
  { type: 'testimonials', name: 'Testimoni',     icon: Star,                description: 'Review pelanggan' },
  { type: 'cta',          name: 'Call to Action', icon: Zap,                description: 'Tombol aksi' },
  { type: 'features',     name: 'Fitur',         icon: Grid3X3,             description: 'Grid keunggulan' },
  { type: 'video',        name: 'Video',         icon: Play,                description: 'Embed YouTube' },
  { type: 'faq',          name: 'FAQ',           icon: HelpCircle,          description: 'Accordion Q&A' },
  { type: 'gallery',      name: 'Galeri',        icon: GalleryHorizontalEnd,description: 'Grid gambar' },
  { type: 'pricing',      name: 'Tabel Harga',   icon: CreditCard,          description: 'Paket harga' },
  { type: 'countdown',    name: 'Countdown',     icon: Timer,               description: 'Hitung mundur' },
  { type: 'stats',        name: 'Statistik',     icon: BarChart3,           description: 'Angka counter' },
  { type: 'map',          name: 'Peta',          icon: MapPin,              description: 'Google Maps' },
  { type: 'social',       name: 'Social Links',  icon: Share2,              description: 'Media sosial' },
  { type: 'team',         name: 'Tim',           icon: Users,               description: 'Anggota tim' },
  { type: 'logos',        name: 'Logo / Brand',  icon: Award,               description: 'Logo partner' },
  { type: 'newsletter',   name: 'Newsletter',    icon: Mail,                description: 'Form email' },
  { type: 'spacer',       name: 'Spacer',        icon: SeparatorHorizontal, description: 'Jarak kosong' },
  { type: 'divider',      name: 'Divider',       icon: Minus,               description: 'Garis pemisah' },
  { type: 'html',         name: 'Custom HTML',   icon: Code2,               description: 'HTML/Script/CSS' }
];

export default function BlockPalette({ onAddBlock, templates = [] }) {
  const handleAdd = (blockType) => {
    const tmpl = templates.find(t => t.type === blockType.type);
    const defaultContent = tmpl?.default_content || {};
    onAddBlock({
      id: Math.random().toString(36).substr(2, 8),
      type: blockType.type,
      content: { ...defaultContent },
      style: {},
      order: 0,
      is_visible: true
    });
  };

  return (
    <div className="space-y-2">
      <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider px-1">Tambah Block</p>
      <div className="grid grid-cols-2 gap-2">
        {BLOCK_TYPES.map(bt => {
          const Icon = bt.icon;
          return (
            <button
              key={bt.type}
              onClick={() => handleAdd(bt)}
              className="flex flex-col items-center gap-1.5 p-3 rounded-lg border border-slate-200 bg-white hover:border-blue-400 hover:bg-blue-50 transition-all text-center group cursor-pointer"
            >
              <Icon size={20} className="text-slate-400 group-hover:text-blue-600 transition-colors" />
              <span className="text-xs font-medium text-slate-600 group-hover:text-blue-700">{bt.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export { BLOCK_TYPES };
